export default {"src":"/_next/static/media/KneePainandDegeneration.6575eec3.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};